// extracted by mini-css-extract-plugin
export var childrenContainer = "_4f-0";
export var virtualScrollArea = "_4f-1";